var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailGreen = function SvgMailGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    x: 0.5,
    fill: "#3A786C",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.78 8.028H8.198A2.2 2.2 0 0 0 6 10.226v9.282a2.2 2.2 0 0 0 2.198 2.198h13.578a2.2 2.2 0 0 0 2.198-2.198V10.23a2.197 2.197 0 0 0-2.194-2.202m1.194 11.48c0 .659-.536 1.194-1.194 1.194H8.198a1.195 1.195 0 0 1-1.194-1.194V10.23c0-.659.536-1.194 1.194-1.194h13.578c.658 0 1.194.535 1.194 1.194v9.278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.336 14.752 4.395-3.942a.505.505 0 0 0 .038-.71.505.505 0 0 0-.71-.038l-6.063 5.441-1.182-1.056q-.007-.006-.008-.011a1 1 0 0 0-.082-.07l-4.812-4.308a.5.5 0 0 0-.71.041.5.5 0 0 0 .04.71l4.448 3.976-4.429 4.147a.504.504 0 0 0 .688.736l4.496-4.206 1.22 1.09a.5.5 0 0 0 .67-.004l1.253-1.123 4.47 4.247a.502.502 0 1 0 .692-.729z"
  })))));
};
export default SvgMailGreen;